import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Heading, ButtonSpace } from './styles';
import { Container } from '../../layout';
import ResponseTap from '../../response-tap';

/**
 * The Collection CTA displays either/both of a phone number (with ResponseTap)
 * and a link to a form also on the page. The button for the form scrolls the page
 * to the form element.
 */
const CollectionCta = ({ phoneNumber, formNode, responseTapClass }) => {
  if (!phoneNumber && !formNode) return null;
  return (
    <Wrapper>
      <Container>
        <Heading>Have furniture to donate? We’ll collect it for free. </Heading>
        <p>
          Simply call or submit a form and we’ll arrange a pick up from your
          home at a time to suit you.
        </p>

        {phoneNumber && (
          <ButtonSpace bg="secondary-on-dark">
            {/** Note: Response Tap automatically inserts `a` tags to call */}
            Call{' '}
            {responseTapClass ? (
              <ResponseTap rtId={responseTapClass}>{phoneNumber}</ResponseTap>
            ) : (
              phoneNumber
            )}
          </ButtonSpace>
        )}
        {formNode && (
          <ButtonSpace
            bg="secondary-on-dark"
            onClick={() => {
              const firstFocusable = [
                ...formNode.querySelectorAll('input, textarea'),
              ].find((el) => !el.hidden && el.id.indexOf('recaptcha') === -1);
              if (firstFocusable && Object.keys(firstFocusable).length) {
                formNode.scrollIntoView();
                firstFocusable.focus();
              }
            }}
          >
            Furniture collection form
          </ButtonSpace>
        )}
      </Container>
    </Wrapper>
  );
};

CollectionCta.propTypes = {
  phoneNumber: PropTypes.string,
  formNode: PropTypes.instanceOf(PropTypes.element),
  responseTapClass: PropTypes.string,
};
export default CollectionCta;
